// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2IrVp","rootSuccess":"CompleteLink_rootSuccess__Emlu8","rootFailure":"CompleteLink_rootFailure__1_6z9","isDisabled":"CompleteLink_isDisabled__1SrLS"};